// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { TelegramMutationDocument, type TelegramMutation, type TelegramMutationVariables } from './TelegramMutation';

export async function getTelegramMutationClient(variables: TelegramMutationVariables) {
  return fetchGraphqlClient<TelegramMutation, TelegramMutationVariables>(TelegramMutationDocument, "TelegramMutation", { variables });
}
export const useTelegramMutation = (options?: MutationOptions) => useMutation<TelegramMutation, TelegramMutationVariables>(getTelegramMutationClient, options);